import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from 'app/components/ui/select';
import { Languages } from 'lucide-react';
import { Settings } from 'luxon';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const languages = {
  en: { nativeName: 'English' },
  ko: { nativeName: 'Korean' },
  ro: { nativeName: 'Romanian' },
};

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const [currentLanguage, setCurrentLanguage] = useState(
    i18n.language.split('-')[0], // cover the cases like en-GB
  );

  const handleChange = (value: string) => {
    setCurrentLanguage(value);
    i18n.changeLanguage(value);
  };

  useEffect(() => {
    setCurrentLanguage(i18n.language);

    Settings.defaultLocale = i18n.language;
  }, [i18n.language]);

  return (
    <Select defaultValue={currentLanguage} onValueChange={handleChange}>
      <SelectTrigger className="w-fit gap-1 border-none outline-none">
        <Languages size={16} />
        <SelectValue placeholder="Language" />
      </SelectTrigger>
      <SelectContent>
        {Object.keys(languages).map(code => (
          <SelectItem key={code} value={code}>
            {languages[code].nativeName}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default LanguageSwitcher;
